import React from 'react'
import styled from 'styled-components'
import Link from 'atoms/Link'
import { ConfigConsumer } from 'contexts/config-context'

const StyledLink = styled(Link)`
    color: rgba(162, 173, 184, 1);
    margin: 0 24px 0 0;

    &:hover {
        color: #fff;
    }

    &:last-child {
        margin:0;
    }
`

function LoggedOutNav (props) {
  return (
    <ConfigConsumer>
      {config => (
        <React.Fragment>
          <StyledLink href={config.helpUrl}>Help</StyledLink>
          <StyledLink href={config.loginUrl}>Login</StyledLink>
          <Link type="button" href={config.signupUrl}>Sign Up</Link>
        </React.Fragment>
      )}
    </ConfigConsumer>
  )
}

export default LoggedOutNav



// WEBPACK FOOTER //
// ./src/molecules/LoggedOutNav.js